import ChoiceField from 'admin-config/lib/Field/ChoiceField';

const categories = [
    {"label": "Automotive", value: 1},
    {"label": "BusinessNews", value: 2},
    {"label": "Celebrities", value: 3},
    {"label": "Classifieds", value: 4},
    {"label": "EmergencyServices", value: 5},
    {"label": "Entertainment", value: 6},
    {"label": "Food", value: 7},
    {"label": "Government", value: 8},
    {"label": "Lifestyle", value: 9},
    {"label": "Magazines", value: 10},
    {"label": "GeneralNews", value: 11},
    {"label": "OtherNonMedia", value: 12},
    {"label": "Politics", value: 13},
    {"label": "RadioStations", value: 14},
    {"label": "Sport", value: 15},
    {"label": "Style", value: 16},
    {"label": "Tabloids", value: 17},
    {"label": "Technology", value: 18},
    {"label": "Television", value: 19},
    {"label": "Travel", value: 20},
    {"label": "ViralNews", value: 21},
    {"label": "Culture", value: 22},
    {"label": "Science", value: 23},
    {"label": "Startups", value: 24},
    {"label": "Politicians", value: 25},
    {"label": "MediaIndustry", value: 26},
    {"label": "Health", value: 27},
    {"label": "SportTeams", value: 28},
    {"label": "Controversial", value: 29},
    {"label": "Satire", value: 30},
    {"label": "LGBT", value: 31}
];

class CategoriesField extends ChoiceField {
    constructor(name) {
        super(name).choices(categories);
        this._type = "choices";
    }
}
module.exports = CategoriesField;



// WEBPACK FOOTER //
// ./client/app/fields/categories.js